// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"TrendChart-primaryButton-3FVrvu","trendChart":"TrendChart-trendChart-D6TnQn"};